import { render, staticRenderFns } from "./EditTipopessoaPage.vue?vue&type=template&id=c402c082"
import script from "./EditTipopessoaPage.vue?vue&type=script&lang=js"
export * from "./EditTipopessoaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports